export const profile = {
  title: "Perfil",
  info: {
    title: "Información del Usuario",
    email: "Email",
    firstName: "Nombre",
    lastName: "Apellido",
    cpf: "CPF", // Consider if you need a different ID for Argentina (e.g., DNI, CUIL)
    update: "Actualizar Perfil",
    birthday: "Fecha de Nacimiento",
  },
  password: {
    title: "Cambiar Contraseña",
    currentPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    confirmPassword: "Confirmar Contraseña",
    update: "Actualizar Contraseña",
    success: "Contraseña actualizada correctamente",
    error: "Error al actualizar la contraseña",
    mismatch: "Las nuevas contraseñas no coinciden",
    tooShort: "La contraseña debe tener al menos 8 caracteres",
    // setTitle: "Actualización de Contraseña",
  },
  update: {
    success: "Perfil actualizado correctamente",
    error: "Error al actualizar el perfil",
  },
  affiliate: {
    title: "Programa de Afiliados",
    cardDescription:
      "Nuestro programa de afiliados es simple, por cada pago realizado por una referencia tuya, recibirás una comisión en créditos de acuerdo a tu nivel.",
    cardDescription2:
      "El sistema de afiliados está sujeto a reajustes y cambios, según nuestras políticas de afiliados.",
    tiers: {
      level: "Nivel",
      requirement: "Requisito",
      commission: "Tasa de Comisión",
      standard: "Estándar", // Or "Básico"
      standardReq: "Hasta $100 en referencias totales", // Consider currency
      silver: "Plata",
      silverReq: "$100 a $500 en referencias totales", // Consider currency
      gold: "Oro",
      goldReq: "Más de $500 en referencias totales", // Consider currency
    },
    yourId: "Tu ID de Afiliado:",
    copy: "Copiar ID",
    copied: "¡Copiado al portapapeles!",
    link: "Tu Link de Afiliado:",
    copyLink: "Copiar Link",
    linkCopied: "¡Link copiado al portapapeles!",
    join: "Convertirse en Afiliado", // Or "Unirse al Programa de Afiliados"
    success: "¡Ahora sos un afiliado!",
    error: "Error al convertirse en afiliado",
    earnings: {
      title: "Tus Ganancias",
      total: "Ganancias Totales",
      pending: "Ganancias Pendientes",
      referrals: "Total de Referencias", // "Referencias" is better than "Indicaciones"
      recentEarnings: "Ganancias Recientes",
      noEarnings: "Aún no hay ganancias",
      source: "Fuente",
      amount: "Monto", // More common than "Valor" for money
      status: "Estado",
      date: "Fecha",
    },
  },
};
